export const cloneDeep = <T>(value: T): T => {
    if ('structuredClone' in window) {
        return structuredClone(value);
    }

    return JSON.parse(JSON.stringify(value));
};
